export default __webpack_public_path__ + "static/media/5ed601c20150d6fcf2b07b20baa0cafa1577722225128.4dcda6db.webp";